import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

const fragments = {
	BTN: '[data-fragment="AutomaticLogout.btn"]',
};

class AutomaticLogout extends WebComponent {

	didMount() {

		this.btnElement = this.element.querySelector(fragments.BTN);

		let timeout = null;

		const resetTimer = () => {
			clearTimeout(timeout);
			timeout = setTimeout(() => {
				this.btnElement.click();
			}, 60*1000); // 60 vterin neaktivity
		}

		resetTimer();

		window.addEventListener("mousemove", resetTimer);
		window.addEventListener("keydown", resetTimer);
		window.addEventListener("scroll", resetTimer);
		window.addEventListener("click", resetTimer);
	}


}

export default AutomaticLogout;




// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/AutomaticLogout.js